import { useSelector } from 'react-redux'
import { TableCell } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { getIsSetBundlePriceEnabled } from '~/store/reducers/constants'
import type { Invoice, InvoiceLineItem } from '~/types'
import { formatMoneyRange, getTotal } from '~/utils/invoiceUtils'

const useStyles = makeStyles(
  () => ({
    subTotalCell: {
      fontWeight: 500,
      minWidth: 90,
      maxWidth: 92,
    },
  }),
  { name: 'ItemTotalCellBody' },
)

export interface ItemTotalCellBodyProps {
  className?: string
  hidePrice?: boolean
  invoice: Invoice
  isDeclined: boolean
  item: InvoiceLineItem
}

const ItemTotalCellBody = ({
  item,
  invoice,
  isDeclined,
  hidePrice = false,
  className,
}: ItemTotalCellBodyProps) => {
  const classes = useStyles()
  const isSetBundlePriceEnabled = useSelector(getIsSetBundlePriceEnabled)

  const subTotal = getTotal(item, invoice, isSetBundlePriceEnabled)

  const showPrice = !isDeclined && !hidePrice

  return (
    <TableCell
      align="right"
      className={classNames(className, classes.subTotalCell)}
    >
      {showPrice && formatMoneyRange(subTotal)}
    </TableCell>
  )
}

export default ItemTotalCellBody
